import { z } from "zod";

const emailPattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/;
const phonePattern = /^[+]?[()]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/;

const nameField = z
  .string()
  .trim()
  .min(1, "Моля, въведете Вашето име");

const emailField = z
  .string()
  .trim()
  .min(1, "Моля, въведете имейл-адрес")
  .regex(emailPattern, "Невалиден имейл-адрес");

const phoneField = z
  .string()
  .trim()
  .min(1, "Моля, въведете телефонен номер")
  .regex(phonePattern, "Невалиден телефонен номер");

const dealershipField = z
  .string()
  .trim()
  .min(1, "Моля, изберете предпочитано представителство");

export const getInTouchSchema = z.object({
  name: nameField,
  email: emailField,
  phone: phoneField,
  dealership: dealershipField,
  text: z
    .string()
    .trim()
    .min(1, "Моля, въведете Вашето запитване"),
});

export const singleCarTestdriveSchema = z.object({
  name: nameField,
  email: emailField,
  phone: phoneField,
  dealership: dealershipField,
  newsletter: z.boolean().default(false),
});

export const singleCarProposalSchema = z.object({
  name: nameField,
  email: emailField,
  phone: phoneField,
  dealership: dealershipField,
  leasing: z.boolean().default(false),
  newsletter: z.boolean().default(false),
});

export const pumaCampaignSchema = z.object({
  name: nameField,
  email: emailField,
  phone: phoneField,
  dealership: dealershipField,
});

export const pumaFamilySchema = pumaCampaignSchema.extend({
  model: z.enum(["Puma", "Puma Gen-E"], { error: "Моля, изберете модел" }),
});
